import React, { useState } from 'react';
import useAsyncEffect from 'src/hooks/useAsyncEffect';
import { StatusCircle } from 'src/components/common/Status';
import { getProductSegment } from '../../api/productAlerts.api';
import ProductSegment from '../../types/ProductSegment';
import styles from './SegmentInfo.module.less';

type PropsSegmentInfo = {
  segmentId: string;
};

export const SegmentInfo: React.FC<PropsSegmentInfo> = ({ segmentId }) => {
  const [segment, setSegment] = useState<ProductSegment | null>(null);

  useAsyncEffect(async () => {
    const currentSegment = await getProductSegment(segmentId);
    setSegment(currentSegment);
  }, []);

  return (
    <div className={styles.root}>
      <h2>{segment?.productSegmentName}</h2>
      {segment && (
        <div className={styles.row}>
          <div className={styles.subRow}>
            <h4 className={styles.boldText}>Status:</h4>
            <p className={styles.text}>
              <StatusCircle value={segment.active} />
            </p>
          </div>
          <div className={styles.subRow}>
            <h4 className={styles.boldText}>Shared:</h4>
            <p className={styles.text}>{segment?.shared ? 'Public' : 'Private'}</p>
          </div>
        </div>
      )}
    </div>
  );
};
